import { OncallAssignmentResponse } from '@/modules/Oncall/types/response'

export interface DashboardTimelineProps {
    defaultDays?: number
    /** Filter schedules by department */
    departmentId?: number
    /** Date navigation mode: rolling starts today, calendar snaps to Monday-Sunday */
    weekMode?: 'calendar' | 'rolling'
    /** Render active schedule rows even when no visible assignments exist */
    showEmptySchedules?: boolean
}

/** Merged span for consecutive same-member assignments */
export interface AssignmentSpan {
    memberName: string | null
    startIdx: number
    colSpan: number
    timeFrom: string
    timeTo: string
    scheduleId: number
    rotationId?: number
    isTentative?: boolean
}

/** Processed schedule with grouped rotations */
export interface ScheduleGroup {
    scheduleId: number
    scheduleName: string
    rotations: Record<
        number,
        {
            rotationId: number
            rotationName: string
            assignments: OncallAssignmentResponse[]
        }
    >
    legacyAssignments: OncallAssignmentResponse[]
}

// Grid template: fixed label + N equal day columns
export const LABEL_WIDTH = 120
export const MIN_COL_WIDTH = 60

/** HSL color set for schedule/rotation rows */
export interface ScheduleColor {
    bg: string
    border: string
    text: string
}
